export const Data = [
  {
    id: "panel1",
    question: "What are the various stages in the recruitment process?",
    answer:
      "The recruitment process consists of two rounds:\nRound 1 is an online test.\nRound 2 is a personal interview.\n\nGet ready to join the revolution in making",
  },
  {
    id: "panel2",
    question: "What are your expectations from an individual in design domain?",
    answer:
      "What matters is your willingness, enthusiasm and creativity in designing. Design domain in our chapter is comprised of Poster Designing, Graphic Designing, UI/UX and much more.",
  },
  {
    id: "panel3",
    question:
      "What are the various responsibilities of a person in management domain?",
    answer:
      "Management domain mainly aims at improving your teamwork and leadership qualities. You'll be involved in handling various events in Access Denied and Synergy. It also comprises of PnM and Sponsorship responsibilities.",
  },
  {
    id: "panel4",
    question:
      "Can ECE students only apply for recruitment or people from multiple branches can apply?",
    answer:
      " No, people from other branches can apply too.All that matters is your willingness and sense of responsibility. The various domains in our chapter includes technical, management, design, editorial and photography.",
  },
  {
    id: "panel5",
    question: "What should we expect from IETE while joining Tech ECE domain?",
    answer:
      "Tech ECE in IETE will help you explore the various domains within ECE. You'll also get to organise several webinars and work on various interesting projects under the guidance of seniors.",
  },
  {
    id: "panel6",
    question:
      "I am a beginner in coding.Will I face any difficulties while joining Tech CSE domain?",
    answer:
      "No, not at all. We cover the things from the very basic level and try our best to inculcate all your skills. All that matters is your willingness and grit in the learning process.",
  },
  {
    id: "panel7",
    question:
      "Will the chapter help me to improve my skills to participate in Hackathons?",
    answer:
      "Yes, absolutely! Our members are well known for achieving several victories at prestigious Hackathons and we can help you in becoming one of them.Till then keep hustling and stay tuned!",
  },
  {
    id: "panel8",
    question: "Can I apply for multiple domains in the recruitment?",
    answer:
      "Yeah, sure! You'll be given a chance for applying various domains in the recruitment and you can join in if you clear all the rounds in the recruitment process.",
  },
  {
    id: "panel9",
    question: "What is IETE ISF famous for?",
    answer:
      "IETE is India's leading recognised professional society devoted to the development of Electronics, Telecommunication and IT. IETE has also been awarded the Best Chapter in 2018-19 in VIT.\nWe are well known to conduct premium Hackathons like Access Denied and Synergy.\nVisit our website for more information about the events conducted by us!",
  },
  {
    id: "panel10",
    question:
      "Will it be easy to balance academic activities along with chapter work?",
    answer:
      "Balance is not something you find, it's something you create. All what matters is your ability to explore new things and create balance with each passing day in IETE-ISF.",
  },
];
